import React from "react";
import { RefreshCw, Plus } from "lucide-react";
import { useTheme } from "../../contexts/ThemeContext";

/**
 * Reusable Page Header Component
 * Displays title, badge, refresh and add buttons
 */
const PageHeader = ({
  title,
  count,
  onRefresh,
  onAdd,
  addButtonText = "Add",
  addButtonTextMobile = "Add",
  loading = false,
  actionLoading = false,
  showRefresh = true,
  showAdd = true,
}) => {
  const { colors } = useTheme();

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
      <div className="flex items-center space-x-3">
        <h1 className={`text-xl md:text-2xl font-bold ${colors.textPrimary}`}>
          {title}
        </h1>
        {count !== undefined && (
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium bg-white/10 ${colors.textSecondary} border border-white/5`}>
            {count}
          </span>
        )}
      </div>

      <div className="flex items-center space-x-2">
        {showRefresh && onRefresh && (
          <button
            onClick={onRefresh}
            disabled={loading || actionLoading}
            className={`flex items-center space-x-2 px-3 py-2 min-h-[44px] rounded-lg border ${colors.borderSecondary} bg-transparent transition-all duration-200 ${colors.textSecondary} hover:text-white hover:bg-white/5`}
          >
            <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
            <span className="text-sm font-medium hidden sm:inline">Yenile</span>
          </button>
        )}

        {showAdd && onAdd && (
          <button
            onClick={onAdd}
            disabled={loading || actionLoading}
            className="flex items-center space-x-2 px-4 py-2 min-h-[44px] bg-violet-600 text-white rounded-lg transition-all duration-200 hover:bg-violet-700 font-bold text-sm"
          >
            <Plus className="w-4 h-4" />
            <span className="hidden sm:inline">{addButtonText}</span>
            <span className="sm:hidden">{addButtonTextMobile}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
